export const technicalSkills = [
  { name: "React.js", icon: "react", color: "#61DBFB", proficiency: "95%" },
  { name: "Next.js", icon: "react", color: "#61DBFB", proficiency: "90%" },
  { name: "TypeScript", icon: "typescript", color: "#007ACC", proficiency: "90%" },
  { name: "Node.js", icon: "nodejs", color: "#68A063", proficiency: "95%" },
  { name: "Express.js", icon: "nodejs", color: "#68A063", proficiency: "92%" },
  { name: "MongoDB", icon: "mongodb", color: "#47A248", proficiency: "90%" },
  { name: "PostgreSQL", icon: "postgresql", color: "#336791", proficiency: "80%" },
  { name: "Docker", icon: "docker", color: "#2496ED", proficiency: "85%" },
  { name: "AWS", icon: "aws", color: "#FF9900", proficiency: "80%" },
  { name: "GraphQL", icon: "graphql", color: "#E10098", proficiency: "80%" },
];

export const professionalSkills = [
  {
    name: "Backend Architecture",
    proficiency: "95%",
    dashOffset: 502 - (502 * 95) / 100,
  },
  {
    name: "API Design",
    proficiency: "95%",
    dashOffset: 502 - (502 * 95) / 100,
  },
  {
    name: "Database Design",
    proficiency: "90%",
    dashOffset: 502 - (502 * 90) / 100,
  },
  {
    name: "Performance Optimization",
    proficiency: "88%",
    dashOffset: 502 - (502 * 88) / 100,
  },
  {
    name: "Cloud Deployment",
    proficiency: "85%",
    dashOffset: 502 - (502 * 85) / 100,
  },
  {
    name: "Problem Solving",
    proficiency: "95%",
    dashOffset: 502 - (502 * 95) / 100,
  },
];
